import React, { useEffect, useState } from 'react';
import { TbBulb } from 'react-icons/tb';
import { MdTimeline } from 'react-icons/md';
import { FaCogs, FaHammer, FaIndustry, FaCheckCircle } from 'react-icons/fa';
import './Services.css';
import { useTheme } from '../../contexts/ThemeContext';

function Services() {
  const { theme } = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);
  
  const services = [
    {
      id: 1,
      title: 'Planning & Designing',
      description: 'Comprehensive planning and innovative design solutions for your construction projects.',
      icon: <TbBulb />,
      features: ['Architectural Design', 'Structural Planning', '3D Modeling', 'Project Consultation']
    },
    {
      id: 2,
      title: 'Construction Services',
      description: 'End-to-end construction services with quality assurance and timely delivery.',
      icon: <FaHammer />,
      features: ['Residential Construction', 'Commercial Buildings', 'Infrastructure', 'Renovation']
    },
    {
      id: 3,
      title: 'Manufacturing',
      description: 'High-quality manufacturing of construction materials and precast products.',
      icon: <FaIndustry />,
      features: ['Precast Elements', 'Concrete Products', 'Custom Manufacturing', 'Quality Control']
    },
    {
      id: 4,
      title: 'Project Management',
      description: 'Professional project management ensuring efficient execution and delivery.',
      icon: <MdTimeline />,
      features: ['Timeline Management', 'Resource Planning', 'Quality Assurance', 'Cost Control']
    }
  ];
  
  return (
    <div className='modern-services-container'>
      {/* Hero Section */}
      <section className='services-hero-section'>
        <div className='hero-background'></div>
        <div className='hero-overlay'></div>
        <div className='container hero-content'>
          <div className={`hero-text text-center ${isVisible ? 'animate-in' : ''}`}>
            <h1 className='hero-title'>
              <span className='text-gradient'>Our</span> Services
            </h1>
            <p className='hero-description'>
              Comprehensive construction and manufacturing solutions tailored to your needs
            </p>
          </div>
        </div>
      </section>
      
      {/* Services Section */}
      <section className='services-section'>
        <div className='container'>
          <div className='section-header text-center mb-5'>
            <h2 className='section-title'>
              <FaCogs className='section-icon' />
              <span className='text-gradient'>Our</span> Services
            </h2>
            <p className='section-description'>
              Comprehensive range of construction and manufacturing services
            </p>
          </div>
          <div className='services-grid'>
            {services.map((service, index) => (
              <div key={service.id} className='service-card' data-aos='fade-up' data-aos-delay={index * 100}>
                <div className='service-icon fs-2'>
                  {service.icon}
                </div>
                <div className='service-content'>
                  <h3 className='service-title'>{service.title}</h3>
                  <p className='service-description'>{service.description}</p>
                  <div className='service-features'>
                    {service.features.map((feature, idx) => (
                      <span key={idx} className='feature-item'>
                        <FaCheckCircle className='feature-check' />
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
